import { useEffect, useRef, useState } from 'react';
import './MultiSelectDropdown.scss';
interface MultiSelectProps {
  defaultText: string;
  options: { key: string; value: number }[];
  selectedValues: number[];
  onChange: (selectedValues: number[]) => void;
  isDisabled?: boolean;
}

export default function MultiSelectDropdown({
  defaultText,
  options,
  selectedValues,
  onChange,
  isDisabled,
}: MultiSelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (value: number) => {
    const newSelectedValues = selectedValues.includes(value)
      ? selectedValues.filter((v) => v !== value)
      : [...selectedValues, value];
    onChange(newSelectedValues);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const [selectedText, setSelectedText] = useState(defaultText);
  useEffect(() => {
    const selectedText =
      selectedValues.length === 0
        ? defaultText
        : options
            .filter((option) => selectedValues.includes(option.value))
            .map((option) => option.key)
            .join(', ');

    setSelectedText(selectedText);
  }, [selectedValues, defaultText, options]);

  return (
    <div className="multi-select-dropdown" ref={dropdownRef}>
      <button className="multi-select-button" onClick={handleToggle} disabled={isDisabled}>
        {selectedText}
      </button>
      {isOpen && (
        <div className="multi-select-menu">
          <ul style={{ padding: 0 }}>
            {options.map((option, i) => (
              <li key={option.value} style={{ listStyleType: 'none' }}>
                <label className="multi-select-option">
                  <input
                    type="checkbox"
                    name={option.key}
                    value={option.value}
                    defaultChecked={selectedValues.includes(option.value)}
                    onChange={() => handleCheckboxChange(option.value)}
                    disabled={isDisabled}
                  />
                  <span className="ml-1">{option.key}</span>
                </label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
